import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-x1 font-bold"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "mt-x2 flex gap-x-x1" }
const _hoisted_5 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_6 = { class: "flex items-center flex-wrap gap-x-x2 gap-y-x1" }
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 3,
  class: "text-11 mt-x2 text-dusty-grey"
}

import { ProductDiscountType, ProductPriceModel } from '@/types/productServerApi';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import authStore from '@/shared/auth/auth.store';
import FreightInfoButton from '@/shared/product/freight-information/ui/FreightInfoButton.vue';
import LogInOrSignUpLinks from '@/b2c/profile/ui/LogInOrSignUpLinks.vue';
import { computed } from 'vue';
import { injectBuyXAndGetYPercent } from '@/shared/checkout/basket/useBuyXAndGetYPercent';
import BuyXAndGetYPercent from '@/shared/checkout/basket/ui/BuyXAndGetYPercent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailPrice',
  props: {
    price: null,
    showFreightInformation: { type: Boolean },
    showBuyXAndGetYPercent: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    price: ProductPriceModel,
    showFreightInformation?: boolean,
    showBuyXAndGetYPercent?: boolean,
}



const globalLabels = useGlobalLabels(GlobalLabels.product);
const buyXAndGetYPctDiscount = injectBuyXAndGetYPercent();

const hasMyBoliaBoostDiscount = computed(() => {
    return props.price.discount?.type === ProductDiscountType.MyBoliaBoost;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, {
      name: "o-anim-fade-200",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          key: __props.price.salesPrice.amount,
          class: "mt-x8"
        }, [
          (__props.price.discount?.expiryLabel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.price.discount.expiryLabel)
                  ? (_openBlock(), _createBlock(BlockLabelWithNamedArguments, {
                      key: 0,
                      label: __props.price.discount.expiryLabel
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(hasMyBoliaBoostDiscount))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(), _createElementBlock("p", {
                    key: __props.price.salesPrice.amount,
                    class: "o-text-h3 whitespace-nowrap"
                  }, _toDisplayString(__props.price.salesPrice.amount), 1)),
                  (__props.price.discount?.percentage)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: __props.price.discount.percentage,
                        class: "o-text-caption px-8 py-4 bg-brandy ml-x2"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(globalLabels).myBoliaDiscount, { discount: __props.price.discount.percentage })), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_4, [
                  (_openBlock(), _createElementBlock("span", {
                    key: __props.price.listPrice.amount,
                    class: "o-text-body whitespace-nowrap"
                  }, _toDisplayString(__props.price.listPrice.amount), 1)),
                  _createElementVNode("span", null, _toDisplayString(_unref(globalLabels).nonMemberDiscountText), 1),
                  (!_unref(authStore).isSignedIn)
                    ? (_openBlock(), _createBlock(LogInOrSignUpLinks, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(), _createElementBlock("span", {
                    key: __props.price.salesPrice.amount,
                    class: "o-text-h3 whitespace-nowrap"
                  }, _toDisplayString(__props.price.salesPrice.amount), 1)),
                  (__props.price.discount)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: __props.price.listPrice.amount,
                        class: "line-through o-text-body"
                      }, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(`${_unref(globalLabels).previousListPrice}:`), 1),
                        _createTextVNode(" " + _toDisplayString(__props.price.listPrice.amount), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!__props.price.discount && _unref(buyXAndGetYPctDiscount) && __props.showBuyXAndGetYPercent)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createVNode(BuyXAndGetYPercent, { label: _unref(buyXAndGetYPctDiscount) }, null, 8, ["label"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (__props.price.discount)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: __props.price.discount.percentage,
                      class: "o-text-caption px-8 py-4 bg-brandy ml-x2"
                    }, [
                      (__props.price.discount.type === _unref(ProductDiscountType).Campaign)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(globalLabels).discount, { discount: __props.price.discount.percentage })), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])),
          (__props.price.ecoTaxPrice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(globalLabels).ecoTaxIncluded) + " " + _toDisplayString(__props.price.ecoTaxPrice.amount), 1))
            : _createCommentVNode("", true)
        ]))
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "o-anim-fade-200",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(FreightInfoButton, {
          key: __props.showFreightInformation,
          "button-css": "c-link mt-x1",
          "has-freight-information": __props.showFreightInformation
        }, null, 8, ["has-freight-information"]))
      ]),
      _: 1
    })
  ]))
}
}

})